var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0249 10.6667C16.0249 11.1382 15.8376 11.5903 15.5042 11.9237C15.1708 12.2571 14.7186 12.4444 14.2471 12.4444H8.0249L5.0249 16V12.5L2.00268 12.4664C0.906849 12.4542 0.0249023 11.5624 0.0249023 10.4665V1.77778C0.0249023 1.30628 0.212203 0.854097 0.545601 0.520699C0.878999 0.187301 1.33118 0 1.80268 0H14.2471C14.7186 0 15.1708 0.187301 15.5042 0.520699C15.8376 0.854097 16.0249 1.30628 16.0249 1.77778V10.6667Z",
    fill: "#9764D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 8V4.315H3.205L4.665 6.89V4.315H5.295V8H4.61L3.15 5.425H3.025V8H2.4ZM6.09629 8V4.315H8.61629V4.885H6.72129V5.785H8.45129V6.355H6.72129V7.43H8.61629V8H6.09629ZM9.76023 8L8.91523 4.315H9.58023L10.1702 7.405H10.2902L10.8802 4.315H11.4402L12.0302 7.405H12.1502L12.7402 4.315H13.4052L12.5552 8H11.6102L11.1602 5.675L10.7102 8H9.76023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.f3e0cc905d5a8c2554b4d959d2970b32.svg";
export { ForwardRef as ReactComponent };